export enum routes {
  LOGIN = "/login",

  QUIZ = "/quiz",
  QUIZ_EVENTS = "/quiz/events",
  QUIZ_EVENTS_ALL = "/quiz/all",

  QUIZ_TEST_PAYOUT = "/quiz/test-payout",
  QUIZ_EVENT = "/quiz",
  QUIZ_NEW_EVENT = "/quiz/event/id/new",

  LEADERBOARD = "/leaderboard",
  LEADERBOARDS_LIST = "/leaderboard/leaderboards",
  LEADERBOARDS_ALL = "/leaderboard/all",

  AUCTION = "/auction",
  AUCTIONS_LIST = "/auction/auctions",
  AUCTIONS_ALL = "/auction/all",

  AUCTIONV2 = "/auctionv2",
  AUCTIONSV2_LIST = "/auctionv2/auctions",
  AUCTIONSV2_ALL = "/auctionv2/all",

  NOTIFICATIONS = "/notifications",
  NOTIFICATIONS_LIST = "/notifications/list",
  NOTIFICATIONS_SEND = "/notifications/send",

  CONFIG = "/config",

  DASHBOARD = "/dashboard"
}
